"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getFilenameForDown () {
        return getFilenameForDown;
    },
    get getFilenameForUp () {
        return getFilenameForUp;
    },
    get getUniqFilenamePrefix () {
        return getUniqFilenamePrefix;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getUniqFilenamePrefix = function() {
    return (0, _dayjs.default)().format('YYYYMMDD_HHmmssSSS');
};
const getFilenameForUp = function(prefix) {
    return prefix + '.up.sql';
};
const getFilenameForDown = function(prefix) {
    return prefix + '.down.sql';
};
